import { render } from "./BillingView.vue?vue&type=template&id=97e451dc&scoped=true"
import script from "./BillingView.vue?vue&type=script&lang=js"
export * from "./BillingView.vue?vue&type=script&lang=js"

import "./BillingView.vue?vue&type=style&index=0&id=97e451dc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97e451dc"]])

export default __exports__